import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "my-auto mr-1 material-icons icon-light" }, " settings ", -1)
const _hoisted_3 = { class: "mb-0.5" }
const _hoisted_4 = { class: "flex flex-col justify-between mt-2 lg:flex-row" }
const _hoisted_5 = { class: "flex flex-col space-y-6" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "mr-2 text-muted" }
const _hoisted_8 = { class: "mr-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons" }, " edit ", -1)
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "error-msg" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons-outlined" }, " done ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons-outlined" }, " close ", -1)
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "mr-2 text-muted" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons" }, " edit ", -1)
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons-outlined" }, " done ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons-outlined" }, " close ", -1)
const _hoisted_22 = { class: "flex flex-col mt-4 md:items-center md:flex-row md:space-x-2" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "flex flex-col items-end mt-4 lg:mt-0 lg:w-2/5" }
const _hoisted_25 = {
  key: 0,
  class: "mr-auto text-muted"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-lg inline-icon text-danger-dark material-icons-outlined" }, "error_outline", -1)
const _hoisted_27 = {
  key: 1,
  class: "mr-auto text-muted"
}
const _hoisted_28 = { class: "mt-8" }
const _hoisted_29 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 mt-4 lg:grid-cols-2 xl:grid-cols-3"
}
const _hoisted_30 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 mt-4 lg:grid-cols-2 xl:grid-cols-3"
}
const _hoisted_31 = {
  key: 2,
  class: "flex flex-col w-full mt-6 mb-16 text-center select-none"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"6rem"},
  class: "material-icons-outlined opacity-10"
}, " assignment ", -1)
const _hoisted_33 = { class: "opacity-40" }
const _hoisted_34 = {
  key: 3,
  class: "flex w-full mt-4"
}
const _hoisted_35 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_36 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 mt-4 lg:grid-cols-2"
}
const _hoisted_37 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 lg:grid-cols-2"
}
const _hoisted_38 = {
  key: 2,
  class: "flex flex-col w-full mt-6 text-center select-none mb-14"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", {
  style: {"font-size":"6rem"},
  class: "material-icons-outlined opacity-10"
}, "topic", -1)
const _hoisted_40 = { class: "opacity-40" }
const _hoisted_41 = {
  key: 3,
  class: "flex w-full mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EventEditorPreview = _resolveComponent("EventEditorPreview")!
  const _component_EventEditorPreviewSkeleton = _resolveComponent("EventEditorPreviewSkeleton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MinimalExercisePreview = _resolveComponent("MinimalExercisePreview")!
  const _component_MinimalExercisePreviewSkeleton = _resolveComponent("MinimalExercisePreviewSkeleton")!
  const _component_v_tour = _resolveComponent("v-tour")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, {
      hoverable: false,
      filled: true,
      borderLess: true
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("misc.course_settings")), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("teacher_course_dashboard.course_name")), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.currentCourse.name), 1),
              (_ctx.hasPrivileges([_ctx.CoursePrivilege.UPDATE_COURSE]))
                ? (_openBlock(), _createBlock(_component_Btn, {
                    key: 0,
                    outline: true,
                    variant: 'icon',
                    onClick: _ctx.editCourseName
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, !_ctx.editingName]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_10, [
              _createVNode(_component_TextInput, {
                onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.v$.$invalid ? _ctx.v$.$touch() : _ctx.onDoneEditingName()), ["enter"])),
                class: "mr-2 w-96",
                modelValue: _ctx.dirtyCourseName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dirtyCourseName) = $event))
              }, _createSlots({
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("course_creation_form.course_name")) + " ", 1)
                ]),
                _: 2
              }, [
                (_ctx.v$.dirtyCourse.name.$errors.length > 0)
                  ? {
                      name: "errors",
                      fn: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.dirtyCourse.name.$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: error.$uid
                          }, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("validation_errors." + error.$uid)), 1)
                          ]))
                        }), 128))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue"]),
              _createVNode(_component_Btn, {
                outline: true,
                variant: 'icon',
                loading: _ctx.localLoading,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.$invalid ? _ctx.v$.$touch() : _ctx.onDoneEditingName()))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_Btn, {
                outline: true,
                class: "",
                variant: 'icon',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDoneEditingName(true)))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.editingName]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("course_creation_form.course_description")), 1),
                (_ctx.hasPrivileges([_ctx.CoursePrivilege.UPDATE_COURSE]))
                  ? (_openBlock(), _createBlock(_component_Btn, {
                      key: 0,
                      outline: true,
                      variant: 'icon',
                      onClick: _ctx.editCourseDescription
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", {
                class: "mr-3",
                innerHTML: _ctx.currentCourse.description
              }, null, 8, _hoisted_18)
            ], 512), [
              [_vShow, !_ctx.editingDescription]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_19, [
              _createVNode(_component_TextEditor, {
                forceBaseEditor: true,
                class: "w-full mr-2",
                modelValue: _ctx.dirtyCourseDescription,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dirtyCourseDescription) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("course_creation_form.course_description")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_Btn, {
                outline: true,
                variant: 'icon',
                loading: _ctx.localLoading,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDoneEditingDescription()))
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_Btn, {
                outline: true,
                class: "",
                variant: 'icon',
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onDoneEditingDescription(true)))
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.editingDescription]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("teacher_course_dashboard.course_link_for_students")), 1),
              _createVNode(_component_CopyToClipboard, {
                value: _ctx.permalink,
                title: _ctx.$t('event_preview.copy_link'),
                confirmationMessage: _ctx.$t('event_preview.copied_link')
              }, null, 8, ["value", "title", "confirmationMessage"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_Toggle, {
              disabled: !_ctx.hasPrivileges([_ctx.CoursePrivilege.UPDATE_COURSE]),
              modelValue: _ctx.currentCourse.hidden,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeCourseVisibility($event))),
              class: "mb-2 mr-auto",
              labelOnLeft: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("course_creation_form.hide_course")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "modelValue"]),
            (_ctx.currentCourse.hidden)
              ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                  _hoisted_26,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("course_creation_form.hidden_description")), 1)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.$t("course_creation_form.public_description")), 1))
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("teacher_course_dashboard.recent_exams")), 1),
      _createElementVNode("div", null, [
        (!_ctx.loadingEvents)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentExams, (exam, index) => {
                return (_openBlock(), _createBlock(_component_EventEditorPreview, {
                  key: exam + '-' + index,
                  event: exam,
                  allowClose: false,
                  buttonIconsOnly: true
                }, null, 8, ["event"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(_component_EventEditorPreviewSkeleton),
              _createVNode(_component_EventEditorPreviewSkeleton),
              _createVNode(_component_EventEditorPreviewSkeleton)
            ])),
        (!_ctx.loadingEvents && _ctx.mainStore.exams.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.$t("course_events.no_exams")), 1)
            ]))
          : (!_ctx.loadingEvents)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(_component_router_link, {
                  class: "mx-auto link",
                  to: { name: 'CourseExams' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Btn, { variant: 'primary-borderless' }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("teacher_course_dashboard.see_all")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showExercises)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("teacher_course_dashboard.recently_edited_exercises")), 1),
          (!_ctx.loadingExercises)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentExercises, (exercise) => {
                  return (_openBlock(), _createBlock(_component_MinimalExercisePreview, {
                    key: 'e-' + exercise.id,
                    exercise: exercise,
                    selectable: false,
                    hoverable: true,
                    showEdit: true,
                    onEdit: ($event: any) => (
						_ctx.$router.push({
							name: 'CourseExercises',
							hash: '#editor-' + exercise.id,
						})
					)
                  }, null, 8, ["exercise", "onEdit"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(_component_MinimalExercisePreviewSkeleton),
                _createVNode(_component_MinimalExercisePreviewSkeleton),
                _createVNode(_component_MinimalExercisePreviewSkeleton),
                _createVNode(_component_MinimalExercisePreviewSkeleton)
              ])),
          (!_ctx.loadingExercises && _ctx.mainStore.exercises.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("h2", _hoisted_40, _toDisplayString(_ctx.$t("course_exercises.no_exercises")), 1)
              ]))
            : (!_ctx.loadingExercises)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createVNode(_component_router_link, {
                    class: "mx-auto link",
                    to: { name: 'CourseExercises' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Btn, { variant: 'primary-borderless' }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("teacher_course_dashboard.see_all")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_tour, {
      name: "teacherTour",
      steps: _ctx.teacherTourSteps,
      options: _ctx.tourOptions
    }, null, 8, ["steps", "options"]),
    _createVNode(_component_v_tour, {
      name: "newMaterialModuleTour",
      steps: _ctx.newMaterialModuleTourSteps,
      options: _ctx.tourOptions
    }, null, 8, ["steps", "options"]),
    _createVNode(_component_v_tour, {
      name: "demoTeacherTour",
      steps: _ctx.demoTeacherTourSteps,
      options: _ctx.tourOptions
    }, null, 8, ["steps", "options"])
  ]))
}